import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useSubject(type, recordId) {
  const queryKey = ['subjects', type, recordId];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      platformApi.get(`subjects/${type}/${recordId}`, { signal }).json(),
    enabled: !!type && !!recordId,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
